var map = {
	"./Auth/Login": 3685,
	"./Auth/Login.vue": 3685,
	"./Clientes/Detalhes": 6414,
	"./Clientes/Detalhes.vue": 6414,
	"./Clientes/Index": 1765,
	"./Clientes/Index.vue": 1765,
	"./Contacts/Create": 8786,
	"./Contacts/Create.vue": 8786,
	"./Contacts/Edit": 6113,
	"./Contacts/Edit.vue": 6113,
	"./Contacts/Index": 7205,
	"./Contacts/Index.vue": 7205,
	"./Dashboard/Index": 1433,
	"./Dashboard/Index.vue": 1433,
	"./Especificacoes/Create_or_Edit": 3128,
	"./Especificacoes/Create_or_Edit.vue": 3128,
	"./Especificacoes/Index": 7964,
	"./Especificacoes/Index.vue": 7964,
	"./Organizations/Create": 322,
	"./Organizations/Create.vue": 322,
	"./Organizations/Create_or_Edit": 599,
	"./Organizations/Create_or_Edit.vue": 599,
	"./Organizations/Edit": 5036,
	"./Organizations/Edit.vue": 5036,
	"./Organizations/Index": 4242,
	"./Organizations/Index.vue": 4242,
	"./Reports/Index": 6011,
	"./Reports/Index.vue": 6011,
	"./Users/Create": 4570,
	"./Users/Create.vue": 4570,
	"./Users/Edit": 1333,
	"./Users/Edit.vue": 1333,
	"./Users/Index": 5104,
	"./Users/Index.vue": 5104,
	"./Vendas/Create_or_Edit": 2180,
	"./Vendas/Create_or_Edit.vue": 2180,
	"./Vendas/Detalhes": 714,
	"./Vendas/Detalhes.vue": 714,
	"./Vendas/Index": 2283,
	"./Vendas/Index.vue": 2283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;